export default "__VITE_ASSET__BuTrlTq0__"